import { h, FunctionComponent } from 'preact';
import { LabelProps } from '~src/domains/common/types/common';

interface Label {
  for: string;
}

/**
 * ** Required
 * @param label - label to display
 * @param id - for attribute;
 *
 * ** Optional;
 * @param showRequiredIcon - show required icon next to label
 * @param isValid - determines when to show error message
 * @param errorMessage - message displayed when !isValid
 */

const Label: FunctionComponent<LabelProps> = props => {
  const { id, label, isValid } = props;

  return (
    <label for={id}>
      {isValid === false ? (
        <span id={`error-${id}`}>{props.errorMessage}</span>
      ) : props.showRequiredIcon ? (
        <span>
          {label}{' '}
          <span className='asterisk' aria-hidden={true}>
            {' '}
            *
          </span>
          <span className='sr-only'>, required.</span>
        </span>
      ) : (
        label
      )}
    </label>
  );
};

export default Label;
